// extracted by mini-css-extract-plugin
module.exports = {"component":"PaginationButtons_component__2SWdh","text":"PaginationButtons_text__2LldU","button":"PaginationButtons_button__M2JYA"};